import { motion } from 'framer-motion'
import SectionHeading from '../shared/SectionHeading'
import DataCard from '../shared/DataCard'
import { projectsData, personalprojectsData, industrialprojectsData } from '../../data/projectsData'
import './Projects.css'
import { FaProjectDiagram, FaIndustry, FaUser, FaUniversity } from 'react-icons/fa'

const ProjectList = ({ data, icon }) => (
  <motion.div
    className="project-content"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true, margin: '-50px' }}
    transition={{ duration: 0.6, staggerChildren: 0.1 }}
  >
    {data.map((project, i) => (
      <DataCard
        key={i}
        icon={icon}
        fields={[project.name, project.technologies, project.year]}
      />
    ))}
  </motion.div>
)

const Projects = () => (
  <section className="projects-container" id="projects">
    <SectionHeading icon={<FaProjectDiagram />}>Projects</SectionHeading>
    <SectionHeading sub icon={<FaIndustry />}>Industrial Projects</SectionHeading>
    <ProjectList data={industrialprojectsData} icon={<FaIndustry />} />
    {/* <div style={{ marginTop: '3rem' }}>
      <SectionHeading sub icon={<FaUser />}>Personal Projects</SectionHeading>
      <ProjectList data={personalprojectsData} icon={<FaUser />} />
    </div>
    <div style={{ marginTop: '3rem' }}>
      <SectionHeading sub icon={<FaUniversity />}>Academic Projects</SectionHeading>
      <ProjectList data={projectsData} icon={<FaUniversity />} />
    </div> */}
  </section>
)

export default Projects
